import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=93337130&scoped=true"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=93337130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93337130",
  null
  
)

export default component.exports